import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { currentLoginStateSelector } from "../../features/auth/authSlice";
import { sidebarStateSelector } from "../../features/ui/navigationSlice";
import logoImg from "../../images/horizontal-logo.svg";
import getIframeData from "../../utils/iframe";
import AvatarButton from "./components/AvatarButton/AvatarButton";

const iframeData = getIframeData();

export default function MainNavbar() {
  const isLoggedIn = useSelector(currentLoginStateSelector);
  const openSidebar = useSelector(sidebarStateSelector);

  return (
    <header className={`main-header ${openSidebar ? "main-header--hidden" : "p-3"} border-bottom border-light-3`}>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <Link to="/">
              <img style={{ width: "10rem" }} src={logoImg} alt="Kendrick Trade Logo" />
            </Link>
            {iframeData.inIframe && (
              <div className="d-flex align-items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                  <path
                    fillRule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                  />
                </svg>
                <b>YOUR LOGO HERE</b>
              </div>
            )}
          </div>

          {iframeData.inIframe && (
            <div>
              <b>YOUR NAVBAR HERE</b>
            </div>
          )}
          {isLoggedIn ? (
            <AvatarButton />
          ) : (
            <Link className="btn btn-primary" to="/login">
              Log in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
